import React from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../../components';
import css from './Sections.module.css';
import { getSchoolAttribute } from '../../../util/listingDataExtraction';
import { SchoolAttributes } from '../../../util/enums';
import { isArrayLength } from '../../../util/genericHelpers';
import { createSlug } from '../../../util/urlHelpers';

const renderSchoolCard = listings => {
  const { SCHOOL_DISPLAYNAME, TITLE, ID, LOGO } = SchoolAttributes;
  return (
    <>
      {isArrayLength(listings) &&
        listings?.map(listing => {
          const listingTitle = getSchoolAttribute(listing, TITLE);
          const schoolDisplayName = getSchoolAttribute(listing, SCHOOL_DISPLAYNAME);
          const id = getSchoolAttribute(listing, ID);
          const logo = getSchoolAttribute(listing, LOGO);
          const slug = createSlug(listingTitle);
          return (
            <NamedLink
              name="ListingPage"
              params={{ id, slug }}
              className={css.topSellersContent}
              key={id}
            >
              <div className={css.sellerBlock}>
                <div className={css.sellerLeft}>
                  <div className={css.sellerImg}>
                    <img src={logo} alt={'logo'} />
                  </div>
                  <div className={css.sellerInfo}>
                    <h2>{listingTitle}</h2>
                    {/* <p>{schoolDisplayName}</p> */}
                  </div>
                </div>
              </div>
            </NamedLink>
          );
        })}
    </>
  );
};

function ExploreSchools(props) {
  const { listings, intl } = props;
  // Filter and limit the listings to 8 school listings
  const schoolListings = listings.slice(0, 8);
  const schoolCards = renderSchoolCard(schoolListings);

  return (
    <div className={classNames(css.topSchools, css.sectionPadding)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>{intl.formatMessage({ id: 'ExploreSchools.title' })}</h2>
            <p>{intl.formatMessage({ id: 'ExploreSchools.description' })}</p>
          </div>
          <div className={css.rightSec}>
            <NamedLink
              className={classNames(css.viewbtn, css.schoolViewAll)}
              name="SearchPage"
              to={{ search: `pub_listingType=school` }}
            >
              {intl.formatMessage({ id: 'ExploreSchools.viewAll' })}
            </NamedLink>
          </div>
        </div>
        <div className={css.sectionContent}>{schoolCards}</div>
      </div>
    </div>
  );
}

export default ExploreSchools;
